import { FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST } from '../../StitchingInward/stitchingInwardDetails/stitchingInwardDetails.actionsType';
import {
    CREATE_GARMENTS_PO_INWARD_DETAILS_REQUEST,
    CREATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS,
    CREATE_GARMENTS_PO_INWARD_DETAILS_FAILURE,
    DELETE_GARMENTS_PO_INWARD_DETAILS_REQUEST,
    DELETE_GARMENTS_PO_INWARD_DETAILS_SUCCESS,
    DELETE_GARMENTS_PO_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_FAILURE,
    FETCH_GARMENTS_PO_INWARD_DETAILS_REQUEST,
    FETCH_GARMENTS_PO_INWARD_DETAILS_SUCCESS,
    FETCH_GARMENTS_PO_INWARD_DETAILS_FAILURE,
    UPDATE_GARMENTS_PO_INWARD_DETAILS_REQUEST,
    UPDATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS,
    UPDATE_GARMENTS_PO_INWARD_DETAILS_FAILURE,
    RESET_GARMENTS_PO_INWARD_DETAILS_INFO,
    CREATE_GARMENTS_PO_INWARD_DETAILS_FORM,
    UPDATE_GARMENTS_PO_INWARD_DETAILS_FORM,
    FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_FAILURE,
    FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_SUCCESS,
    SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID_V2,
    FETCH_GARMENTS_INWARD_DETAILS_ID_FALIURE,
    FETCH_GARMENTS_INWARD_DETAILS_ID_SUCCESS,
    FETCH_GARMENTS_INWARD_DETAILS_ID_REQUEST,
    FETCH_GARMENTS_INWARD_DETAILS_PART_COM_SUCCESS,
    FETCH_GARMENTS_INWARD_DETAILS_PART_COM_REQUEST,
    FETCH_GARMENTS_INWARD_DETAILS_PART_COM_FALIURE,
    FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_FALIURE,
    FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_SUCCESS,
    FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_REQUEST,
    FETCH_POST_BUNDLE_POST_REQUEST,
    FETCH_POST_BUNDLE_POST_FALIURE,
    FETCH_BUNDLE_INPUT_SUCCESS,
    FETCH_BUNDLE_INPUT_FALIURE,
    FETCH_BUNDLE_INPUT_REQUEST,
    FETCH_POST_BUNDLE_POST_SUCCESS,
    FETCH_DETAIL_DC_NO_SUCCESS,
    FETCH_STYLECODE_REQUEST,
    FETCH_STYLECODE_SUCCESS,
    FETCH_STYLECODE_FAILURE,
    FETCH_STYLECODE_PROGRAM_FAILURE,
    FETCH_STYLECODE_PROGRAM_REQUEST,
    FETCH_STYLECODE_PROGRAM_SUCCESS,
} from './garmentsPoInwardDetails.actionsType';

export const GARMENTS_PO_INWARD_DETAILS = 'garmentsPoInwardDetails';

let initialState = {
    loading: false,
    cuttingDcInwardDetails: [],
    editGridData: [],
    cuttingDcInwardDetailsWithoutId: [],
    garmentsPoInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedState: {},
    errorMessage: '',
    unquieIdData: [],
    updateKey: 0,
    styleCodeload:[],
    styleCodeByProgram:[]
};

export let garmentsPoInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    if (type === 'FETCH_GARMENTS_INWARD_DETAILS_ID_SUCCESS') {
        localStorage.setItem('getIDPayload', JSON.stringify(updatePayload));
    }

    switch (type) {
        case FETCH_GARMENTS_PO_INWARD_DETAILS_REQUEST:
        case CREATE_GARMENTS_PO_INWARD_DETAILS_REQUEST:
        case UPDATE_GARMENTS_PO_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_REQUEST:
        case FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST:
        case DELETE_GARMENTS_PO_INWARD_DETAILS_REQUEST:
        case FETCH_GARMENTS_INWARD_DETAILS_ID_REQUEST:
        case FETCH_GARMENTS_INWARD_DETAILS_PART_COM_REQUEST:
        case FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_REQUEST:
        case FETCH_POST_BUNDLE_POST_REQUEST:
        case FETCH_STYLECODE_REQUEST:
        case FETCH_STYLECODE_PROGRAM_REQUEST:
        case FETCH_STYLECODE_FAILURE:
        case FETCH_STYLECODE_PROGRAM_FAILURE:
        case FETCH_BUNDLE_INPUT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_POST_BUNDLE_POST_SUCCESS:
            return {
                ...state,
                loading: false,
                updateKey: ((prev) => prev + 1)
            }
        case FETCH_GARMENTS_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetails: updatePayload
            };
        case FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetailsWithoutId: updatePayload
            };
        case CREATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_SUCCESS:
            return {
                ...state,
                loading: false,
                editGridData: (updatePayload?.GAI && updatePayload?.GAI.map((x) => ({ ...x, InwardQty: x?.PendingQty, fldFKDCDetailNo: x.FldId, FldQuantity: x?.InwardQty }))) || []
            };

        case FETCH_BUNDLE_INPUT_SUCCESS:
            return {
                ...state,
                loading: false,
                bundleInputValues: updatePayload
            }
        case FETCH_GARMENTS_INWARD_DETAILS_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                getIDPayload: updatePayload?.GAI?.map((x) => ({ ...x, InwardQty: 0 })),
                loadRefresh: updatePayload?.GAI?.map((x, i) => i),
                getSearchedItem: updatePayload?.GAI

            }
        case SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: payload,
                getIDPayload: {
                    GAI: payload
                }
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID_V2:
            return {
                ...state,
                loading: false,
                editGridData: [],
                getIDPayload: {
                    GAI: []
                }
            };

        case FETCH_DETAIL_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                dcNoForDetail: updatePayload
            }
        case UPDATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardDetailsForm: updatePayload
            };
        case DELETE_GARMENTS_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case FETCH_GARMENTS_INWARD_DETAILS_PART_COM_SUCCESS: {
            return {
                ...state,
                partComponent: updatePayload
            }
        }
        case FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_SUCCESS: {
            return {
                ...state,
                unquieIdData: updatePayload
            }
        }
        case RESET_GARMENTS_PO_INWARD_DETAILS_INFO:
            return {
                ...state,
                garmentsPoInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case CREATE_GARMENTS_PO_INWARD_DETAILS_FORM:
        case UPDATE_GARMENTS_PO_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                garmentsPoInwardDetailsForm: {
                    ...state.garmentsPoInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_STYLECODE_SUCCESS:
                    return {
                        ...state,
                        loading: false,     
                        styleCodeload: updatePayload          
                    }
                case FETCH_STYLECODE_PROGRAM_SUCCESS:
                    return {
                        ...state,
                        loading: false,     
                        styleCodeByProgram: updatePayload          
                    }
        case FETCH_GARMENTS_PO_INWARD_DETAILS_FAILURE:
        case CREATE_GARMENTS_PO_INWARD_DETAILS_FAILURE:
        case FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_FAILURE:
        case UPDATE_GARMENTS_PO_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_FAILURE:
        case DELETE_GARMENTS_PO_INWARD_DETAILS_FAILURE:
        case FETCH_GARMENTS_INWARD_DETAILS_ID_FALIURE:
        case FETCH_GARMENTS_INWARD_DETAILS_PART_COM_FALIURE:
        case FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_FALIURE:
        case FETCH_POST_BUNDLE_POST_FALIURE:
        case FETCH_BUNDLE_INPUT_FALIURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
